module.exports = __webpack_public_path__ + "img/jack.7924ad1c.webp";